export class PlatformHelper {
  static isServer() {
    return typeof window === 'undefined';
  }

  static allowServerRendering(clientGuards: Function[], serverGuards: Function[] = []): Function[] {
    return PlatformHelper.isServer() ? serverGuards : clientGuards;
  }
}
